import { __assign } from "tslib";
import React from 'react';
import InternalFormField from './internal';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
export default function FormField(props) {
    var baseComponentProps = useBaseComponent('FormField');
    return React.createElement(InternalFormField, __assign({}, props, { __hideLabel: false }, baseComponentProps));
}
applyDisplayName(FormField, 'FormField');
//# sourceMappingURL=index.js.map